import { useClipboard } from "@chakra-ui/react";
import { CustomPopup } from "@root/components/common/modals/CustomPopup";
import { CHAT_STATUS_GENERAL, TOAST_VARIANT } from "@root/constants";
import { showAlert } from "@root/store/slices/features";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SharePopup from "./popups/sharePopup";
import { UserReactions } from "./roles/components";
import { textToMarkdown } from "@root/utils/streaming";

export const AdditionalInfo = ({ chat, uid }: any) => {
  const [showSharePopup, setShowSharePopup] = useState(false);
  const dispatch = useDispatch();
  const shareByChatKuid = `${process.env.REACT_APP_BASE_URL}/shared/chat/${chat?.chatKuid}`;
  const { t } = useTranslation("common");

  function parseChat(chat: any) {
    try {
      const parsedChat = chat?.meta?.c?.answer
        ? JSON.parse(chat?.meta?.c?.answer)?.answer
        : chat?.meta?.answer
        ? JSON.parse(chat?.meta?.answer)?.answer
        : "";

      // If parsedChat is an array, concatenate doc_name and doc_answer
      if (Array.isArray(parsedChat) && parsedChat?.length > 0) {
        return parsedChat
          ?.map((item) => {
            const docName = item?.doc_name || "Unknown Document";
            const docAnswer =
              typeof item?.doc_answer === "string"
                ? item.doc_answer
                : String(item?.doc_answer || "");
            return `${docName}: ${docAnswer}`;
          })
          ?.join("\n\n\n");
      }

      // For single answers, return as string
      return typeof parsedChat === "string"
        ? parsedChat
        : String(parsedChat || "");
    } catch (err) {
      console.log("Failed to parse chat: ", err);
      return "";
    }
  }

  const parsedChat = parseChat(chat);

  const copyText = textToMarkdown(parsedChat);

  const showToast = () => {
    dispatch(
      showAlert({
        type: TOAST_VARIANT.COPY_SUCCESS,
        message: t("msg.copySuccess"),
      })
    );
  };

  // Function to strip HTML tags and get plain text
  const stripHtml = (html: any) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText; // Only plain text
  };

  const plainText = stripHtml(copyText || "");
  const { onCopy } = useClipboard(plainText || "");

  return (
    <>
      {/* Reactions */}
      {((chat?.meta?.c?.answer &&
        chat?.meta?.c?.status === CHAT_STATUS_GENERAL.COMPLETED) ||
        (chat?.meta?.answer &&
          chat?.meta?.status === CHAT_STATUS_GENERAL.COMPLETED)) && (
        <UserReactions showToast={showToast} onCopy={onCopy} />
      )}
      <CustomPopup
        width="600px"
        title={t("translate.capitalShare")}
        open={showSharePopup}
        onClose={() => setShowSharePopup(false)}
        children={<SharePopup text={shareByChatKuid} showToast={showToast} />}
      />
    </>
  );
};
